<template>
    <!-- Componente del footer del sitio que muestra los datos correspondientes del distribuidor -->
    <footer class="bg-black text-white2 text-sm">
        <div class="container pt-6 pb-10 lg:pt-10 lg:pb-20">
            <h2 class="font-medium text-base">{{ footerInfo.sub_name }}</h2>
            <div class="flex flex-col items-start my-2 lg:flex-row lg:justify-between lg:items-end">
                <div class="md:w-10/12 lg:w-7/12">
                    <p>
                        {{ footerInfo.sub_address }}
                        <br />
                        Horario:<br /><span v-html="footerInfo.sub_schedule" />
                        <br />
                        Tel: {{ footerInfo.sub_phone }}
                    </p>
                    <ul class="flex flex-col" v-if="footerInfo.phones">
                        <li v-for="item in footerInfo.phones">
                            {{ item.name }}: <a :href="'tel:' + item.value">{{ item.value }}</a>
                        </li>
                    </ul>
                    <!-- <contact-dealer-name section="footer"></contact-dealer-name> -->
                </div>
                <div class="flex flex-col md:gap-2 w-full lg:justify-end lg:items-end">
                    <div class="flex flex-col md:gap-2">
                        <div class="mt-5 text-center lg:text-left">Contacta con un asesor de ventas</div>
                        <div class="flex flex-col md:flex-row md:gap-2 md:justify-center lg:justify-start w-full ">
                            <a
                                v-if="footerInfo.sub_wa && footerInfo.sub_wa !== '-'"
                                :href="`https://wa.me/521${footerInfo.sub_wa}`"
                                target="_blank"
                                :data-external="true"
                                class="flex justify-center items-center gap-2 border border-solid border-white2 px-6 lg:px-10 py-2 md:py-1 mt-4 lg:mt-0 transition duration-200 ease-in-out hover:bg-white hover:text-black hidden"
                            >
                                <svg
                                    class="h-6 w-6"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                >
                                    <path
                                        d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
                                    />
                                </svg>
                                WhatsApp
                            </a>
                            <a
                                :href="'tel:' + footerInfo.sub_phone"
                                class="inline-block ml-1 lg:ml-2 border border-solid border-white2 px-6 lg:px-10 py-1 mt-4 lg:mt-0 transition duration-200 ease-in-out hover:bg-white hover:text-black"
                            >
                                <svg
                                    class="inline w-6 h-6 mr-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                    />
                                </svg>
                                Llamar
                            </a>
                            <a
                                :href="`${url}/${webpage}/contacto`"
                                class="inline-block ml-1 lg:ml-2 border border-solid border-white2 px-6 lg:px-10 py-1 mt-4 lg:mt-0 transition duration-200 ease-in-out hover:bg-white hover:text-black"
                            >
                                <svg
                                    class="inline w-6 h-6 mr-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 20 20"
                                    stroke="currentColor"
                                >
                                    <path
                                        d="M10.292,4.229c-1.487,0-2.691,1.205-2.691,2.691s1.205,2.691,2.691,2.691s2.69-1.205,2.69-2.691
                                        S11.779,4.229,10.292,4.229z M10.292,8.535c-0.892,0-1.615-0.723-1.615-1.615S9.4,5.306,10.292,5.306
                                        c0.891,0,1.614,0.722,1.614,1.614S11.184,8.535,10.292,8.535z M10.292,1C6.725,1,3.834,3.892,3.834,7.458
                                        c0,3.567,6.458,10.764,6.458,10.764s6.458-7.196,6.458-10.764C16.75,3.892,13.859,1,10.292,1z M4.91,7.525
                                        c0-3.009,2.41-5.449,5.382-5.449c2.971,0,5.381,2.44,5.381,5.449s-5.381,9.082-5.381,9.082S4.91,10.535,4.91,7.525z"
                                    ></path>
                                </svg>
                                Contacto
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="my-6" />
            <!-- <img
                class="hidden lg:block fill-current text-dark-blue w-52"
                :src="`${url}/front/images/logo_10_anios_horizontal.svg`"
                alt="Logo Hyundai"
            /> -->
            <div class="">
                <img
                    class="w-full max-w-[15rem] mx-auto lg:mx-0"
                    src="/images/logos/logo-fifa-blanco.svg"
                    alt="Logo hyundai fifa"
                    loading="lazy"
                />
            </div>
            <nav class="my-2">
                <ul class="flex flex-col md:flex-row">
                    <li class="mr-4">
                        <a :href="`${url}/${webpage}/mapa-del-sitio`">Mapa del Sitio</a>
                    </li>
                    <li class="mr-4">
                        <a :href="`${url}/${webpage}/legales/aviso-de-privacidad`">Aviso de Privacidad</a>
                    </li>
                    <li class="mr-4">
                        <a :href="`${url}/${webpage}/legales/terminos-y-condiciones`">Términos y Condiciones</a>
                    </li>
                    <li class="mr-4">
                        <a :href="`${url}/${webpage}/legales/aviso-legal`">Aviso Legal</a>
                    </li>
                    <li class="mr-4" v-if="footerInfo.show_news">
                        <a :href="`${url}/${webpage}/noticias`">Noticias</a>
                    </li>
                    <li class="mr-4">
                        <a :href="`${url}/${webpage}/quejas-y-sugerencias`">Quejas y sugerencias</a>
                    </li>
                    <li v-if="footerInfo.pay.value && footerInfo.pay.value !== ' ' && footerInfo.pay.active == true">
                        <a :href="`${footerInfo.pay.value}`" target="_blank" class="mr-4">Pago en linea</a>
                    </li>
                </ul>
            </nav>
            <div class="flex my-4 items-center">
                <SocialMediaSelector :items="footerInfo.social_networks" />
                <a
                    v-if="footerInfo.sub_fb && footerInfo.sub_fb !== '-'"
                    :href="`https://www.facebook.com/${footerInfo.sub_fb}`"
                    target="_blank"
                    class="mr-4"
                    ><span class="icon-facebook text-xl"></span
                ></a>
                <a
                    v-if="footerInfo.sub_tw && footerInfo.sub_tw !== '-'"
                    :href="`https://x.com/${footerInfo.sub_tw}`"
                    target="_blank"
                    class="mr-4"
                >
                    <svg width="19" height="18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.4958 7.7775L17.2333 0.666664H14.6724L10.2933 6.0975L6.40825 0.666664H0.833252L7.33825 9.75833L1.22492 17.3333H3.78659L8.54075 11.4417L12.7583 17.3333H18.3333L11.4958 7.7775ZM9.51242 10.2358L8.30825 8.55333L3.63325 2.0225H5.55825L9.33159 7.28666L10.5341 8.97L15.5491 15.9775H13.6241L9.51242 10.2358Z"
                        />
                    </svg>
                </a>
                <a
                    v-if="footerInfo.sub_ig && footerInfo.sub_ig !== '-'"
                    :href="`https://www.instagram.com/${footerInfo.sub_ig}`"
                    target="_blank"
                    class="mr-4"
                    ><span class="icon-instagram text-xl"></span
                ></a>
            </div>
            <p v-if="webpage === 'arcos-qro' || webpage === 'jurica'" class="text-xs">
                © Copyright {{ currentYear }} SAU MOTORS SA DE CV Hyundai Motor Company
            </p>
            <p v-else class="text-xs">
                © Copyright {{ currentYear }} Hyundai Motor Company. Todos los derechos reservados
            </p>
        </div>
    </footer>
</template>

<script>
import { SocialMediaSelector } from "./features/social-media-selector";

export default {
    components: { SocialMediaSelector },

    props: ["footerData"],
    data() {
        return {
            url: $(".url").text(),
            webpage: $(".webpage").text(),
            // footerInfo: {}
        };
    },
    computed: {
        footerInfo() {
            return JSON.parse(this.footerData);
        },
        currentYear() {
            return new Date().getFullYear();
        },
    },
    // methods: {
    //     getFooterInfo() {
    //         axios.get(`${this.url}/${this.webpage}/get-footer-info`)
    //             .then(resp => {
    //                 this.footerInfo = resp.data
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //             })
    //     }
    // },
    // created() {
    //     this.getFooterInfo()
    // }
};
</script>

<style></style>
